import "./Header.css";
import { useNavigate } from "react-router-dom";
import { routes } from "../../routes";
import { linkService } from "../../link-service";
import { useEffect, useState } from "react";
import CopayLogo from "../../assets/images/copay-logo.png";
import { LoadingComponent } from "../LoadingComponent/LoadingComponent";

export interface HeaderProps {
  userId: string;
}

const Header = (props: HeaderProps) => {
  const [loading, setLoading] = useState(true);
  const [logoUrl, setLogoUrl] = useState(null);
  const navigate = useNavigate();
  const { userId } = props;

  const goToHome = () => {
    const search = userId ? `?userId=${userId}` : "";
    navigate({ pathname: routes.home, search });
  };

  useEffect(() => {
    linkService
      .getBranding()
      .then((data) => {
        setLogoUrl(data.logo.image.src);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <header className="main-header">
      {loading && !logoUrl ? (
        <LoadingComponent />
      ) : (
        <img
          src={logoUrl ?? CopayLogo}
          alt=""
          onClick={goToHome}
          className="company-logo"
          data-testid="company-logo"
        />
      )}
    </header>
  );
};

export default Header;
